<script>
/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    pointsArray: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      }
    }
  },
  methods: {
    getAccessLevelColor(item) {
      if (item === 'Administrator') return 'badge-soft-danger'
      else if (item === 'Editor') return 'badge-soft-secondary'
      else if (item === 'User') return 'badge-soft-success'
      else if (item === 'Union Administrator') return 'badge-soft-primary'
      else if (item === 'Federation Administrator') return 'badge-soft-info'
      else return 'badge-soft-dark'
    },
    myRowClickHandler(content) {
      console.log(content.id + ' - ' + content.title) // This will be the item data for the row
      this.$router.push({
        name: 'Chapters',
        params: { content: content, id: content.id },
      })
    },
    getPercentage()
    {
      var divider=this.pointsArray.totalDividers
      if(divider<=0)
      divider=1
      var value=Math.ceil((this.pointsArray.totalPoints/divider)*100)
      if(value>100)
      value=100

      return value
    },
  },
  computed: {},
  watch: {},
  mounted() {
    //console.log('>>>>>> Image file: '+this.content.coverImage)
  },
}
</script>

<template>

  <a @click="myRowClickHandler(content)" style="cursor: pointer">
    <div class="cardd">
      <div v-if="content.coverImage" class="card-img">
        <!--img :src="content.coverImage" alt="profile"-->
        <image-loader :src="content.coverImage" placeholder="../assets/images/loaders/loading.gif" width="100%"
          height="100%" style="border-radius: 16px" />
      </div>
      <div v-else class="card-img">
        <!--img :src="content.coverImage" alt="profile"-->
        <image-loader src="../assets/images/placeholder.jpg" placeholder="../assets/images/loaders/loading.gif"
          width="100%" height="100%" style="border-radius: 16px" />
      </div>
      <div class="desc">
        <span v-for="(tagInfo, index) in content.tags" :key="index">
          <span class="badge badge-soft-light badge-pill custom_badge float-end text-uppercase">{{ tagInfo
          }}</span>&nbsp;
        </span>
      </div>
      <div class="details">
        <div style="width:100%; height:100%;">
          <h6 class="primary-text">{{ content.title }}</h6>
          <h6 class="secondary-text">{{ content.description }}</h6>
          <div class="bottom">
            <div>&nbsp;</div>
            <div id="textbox">
              <p class="alignleft">Covered so far</p>
              <!--p class="alignright ">{{getPercentage()}}% - ({{this.pointsArray.totalPoints}}/{{this.pointsArray.totalDividers}})</p-->
              <p class="alignright ">{{getPercentage()}}%</p>
            </div>
            <b-progress :max="pointsArray.totalDividers" class="mb-3 progress" height="8px">
              <b-progress-bar class="progress-bar" variant="warning" :value="pointsArray.totalPoints"></b-progress-bar>
            </b-progress>
          </div>

        </div>
      </div>


    </div>
  </a>
</template>


<style lang="scss">

#textbox {
  display: flex;
  flex-flow: row wrap;
}

.alignleft {
  width: 50%;
  text-align: left;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.alignright {
  width: 50%;
  text-align: right;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.cardd {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  border-radius: 16px;
  margin-bottom: 16px;
  //box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
}

.card-img {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  margin: 0px auto 0px auto;
  left: 0;
  right: 0;
  border-radius: 16px;
}

.card-img img {
  height: 100%;
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
}

.desc {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 16px;
}

.primary-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.7px;
  margin: 5px 0;
  text-shadow: 1px 1px #000000;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.secondary-text {
  color: #ffffff;
  font-weight: 100;
  font-size: 12px;
  letter-spacing: 1px;
  margin: 5px 0;
  text-overflow: ellipsis;

  line-height: 1.5em;
  height: 4.5em;
  overflow: hidden;
}

.coveredSoFar {
  width: 100%;
  font-weight: 100;
  font-size: 12px;
  line-height: 30px;
}

.bottom {
  width: 100%;
  display: inline-block;
  align-self: flex-end;
  .progress-bar {
    border-radius: 40px !important;
  }

  .progress {
    border-radius: 40px !important;
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.details {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.185);
  backdrop-filter: blur(10px);
  border-radius: 0 0 16px 16px;
  padding: 15px;
  display: flex;
}

.details>div {
  text-align: left;
}

.buttonn {
  background-color: rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  position: absolute;
  width: 80%;
  left: 10%;
  top: 240px;
  border: none;
  border-radius: 5px;
  padding: 15px 0;
}

.coffe {
  position: absolute;
  left: 50px;
  bottom: 50px;
  transition: all 0.6s ease-in-out;
}

.coffe:hover {
  transform: scale(1.2);
}

.fs-12 {
  font-size: 10px !important;
}

.custom_badge {
  display: inline-block;
  padding: 0.25 em 0.4 em;
  font-size: 70%;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75 rem;
}

.custom_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1 px solid #e2e7f1;
  border-radius: 0.25 rem;
}

.custom_img {
  border-radius: 16px 16px 0px 0px;
  object-fit: contain;
  display: flex;
  width: 100%;
  height: 100%;
}

.custom_loader_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: scale-down;
  display: block;
  width: 100%;
}

.custom_card-body {
  flex: 1 1 auto;
  padding: 15px 25px 5px 0px;
}

.custom_align-items-left {
  align-items: left !important;
}

.col-sm-auto {
  flex: 0 0 auto;
  width: auto;
}
</style>
